<!--组别分类  -->
<template>
	<div class="page-box">
		<div class="left">
			<div class="opt-btn">
				<el-button type="danger" size="mini" @click="addType()">增加分类</el-button>
			</div>
			<div class="table-box" :style="{ '--height': height }">
				<el-table :data="leftTableData" ref="leftRef" highlight-current-row
					:header-cell-style="{ background: '#e4e4e4', border: 'none', color: '#000000', fontWeight: 'bolder', fontSize: '0.8rem', padding: '0.5rem' }"
					:cell-style="{ padding: '0.3rem', fontSize: '0.8rem' }" current-row-key="id"
					@row-click="handleRowClick" border
					style="width:100%;height: calc(100%);overflow-y: hidden;font-size: 0.8rem;">
					<el-table-column prop="teamName" label="" width="50px">
						<template>
							<div class="arrow-icon" style="display: flex;align-items: center;justify-content: center;">
								<img src="/static/arrow.png" style="height: 24px;width:100%;" alt="">
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="classifyName" label="组别分类名称">
					</el-table-column>
					<el-table-column prop="groupAmount" label="数量" width="80px" align="center">
						<template slot-scope="{row}">
							{{ row.groupAmount || 0 }}
						</template>
					</el-table-column>
					<el-table-column prop="teamName" label="操作" align="center" width="120px">
						<template slot-scope="{row}">
							<el-button type="text" @click="editType(row)" size="mini">修改</el-button>
							<el-button type="text" @click="deleteItemType(row)" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="page">
				<el-pagination @size-change="sizeChange" @current-change="currentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20,30, 40, 80, 100]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="totalNum" background :pager-count="5">
				</el-pagination>
			</div>
		</div>
		<div class="line"></div>
		<div class="right">
			<div class="opt-btn">
				<el-button type="danger" size="mini" @click="deleteAllGroup()" plain>删除组别</el-button>
				<el-button type="danger" size="mini" @click="addGroup()">添加组别</el-button>
				<el-button type="danger" size="mini" @click="downloadGroup()">下载</el-button>
			</div>
			<div class="table-box" :style="{ '--height': height }">
				<el-table :data="rightTableData" ref="unitRef" highlight-current-row
					:header-cell-style="{ background: '#e4e4e4', border: 'none', color: '#000000', fontWeight: 'bolder', fontSize: '0.8rem', padding: '0.5rem' }"
					:cell-style="{ padding: '0.3rem', fontSize: '0.8rem' }" current-row-key="id" border
					style="width:100%;height: calc(100%);overflow-y: hidden;font-size: 0.8rem;">
					<el-table-column prop="code" label="组别代码" width="80px" align="center">
						<template> </template>
					</el-table-column>
					<el-table-column prop="name" label="参赛组别">
					</el-table-column>
					<el-table-column prop="dance" label="舞种" align="left" width="100px">
					</el-table-column>
					<el-table-column prop="type" label="类型" align="center" width="70px">
						<template slot-scope="{row}">
							<div> {{ types[row.type] }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="teamName" label="赛制" align="center" width="70px">
						<template slot-scope="{row}">
							<div>{{ getMatchRulesStr(row.matchRules) }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="teamName" label="性别要求" align="center" width="100px">
						<template slot-scope="{row}">
							<div>{{ getgenderRequirementsStr(row.genderRequirements) }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="teamName" label="年龄限制" width="100px">
						<template slot-scope="{row}">
							<div>{{ getageStr(row) }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="teamName" label="操作" align="center" width="80px">
						<template slot-scope="{row}">
							<el-button type="text" @click="delGroupItem(row)" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="page">
				<el-pagination @size-change="rsizeChange" @current-change="rcurrentChange"
					:current-page.sync="rcurrentPage" :page-sizes="[10, 20,30, 40, 80, 100]" :page-size="rpageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="rtotal" background>
					:pager-count="5">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	import AddGroupType from "./add-group-type.vue";
	import AddGroup from "./add-group.vue";
	import {
		openDialog
	} from "../../../../../../../components/fn-dialog";
	import {
		deleteAllGroupClassifyGroups,
		deleteGroupClassify,
		deleteGroupClassisfyGroupById,
		downloadGroupsOfGroupClass,
		pageGroupClassify,
		pageGroupDetailsByGroupClassifyId
	} from "../../../../../api/mymatchs/groupsetitem";
	import {
		get,hasIn
	} from "lodash"
	export default {
		name: "group-type",
		data() {
			return {
				types: ["双人组", "多人组", "单人组", "不限"],
				totalNum: 0,
				pageSize: 30,
				rpageSize: 30,
				currentPage: 1,
				rcurrentPage: 1,
				matchId: '',
				leftTableData: [],
				rightTableData: [],
				rtotal: 0,
				currId: '',
				height: '100%',
			};
		},
		created() {

		},
		mounted() {
			setTimeout(() => {
				this.height = this.$refs.leftRef.$el.clientHeight + 'px'
				const matchId = get(this.$route.query, 'matchId', '');
				if (matchId) {
					this.matchId = matchId;
					this.getPageLocal();
				}
			}, 100)
		},
		methods: {
			async getPageLocal() {
				const params = {
					currPage: this.currentPage,
					pageSize: this.pageSize,
					matchId: this.matchId,
				}
				const res = await pageGroupClassify(params);
				if (res && res.status == 200) {
					this.totalNum = res.data.total;
					this.leftTableData = res.data.list;
					if (this.leftTableData.length > 0 && !this.currId) {
						this.$refs.leftRef.setCurrentRow(this.leftTableData[0]);
						this.currId = this.leftTableData[0].id;
						this.getRightPageLocal();
					}else{
						const item = this.leftTableData.find(item => item.id == this.currId);
						if(item){
							this.$refs.leftRef.setCurrentRow(item);
							this.getRightPageLocal();
						}
					}
				} else {
					res && res.msg && this.$message.error(res.msg);
				}
			},
			sizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1;
				this.getPageLocal();
			},
			currentChange(val) {
				this.currentPage = val;
				this.getPageLocal();
			},

			addType() {
				openDialog(AddGroupType, {
					title: "增加组别分类",
					width: "300px",
					height: "200px",
					params: {
						matchId: this.matchId,
					},
					callback: () => {
						this.currentPage = 1;
						this.getPageLocal();
					}
				})
			},
			editType(row) {
				openDialog(AddGroupType, {
					title: "修改组别分类",
					width: "300px",
					height: "200px",
					params: {
						matchId: this.matchId,
						...row
					},
					callback: () => {
						this.currentPage = 1;
						this.getPageLocal();
					}
				})
			},
			addGroup() {
				openDialog(AddGroup, {
					title: "添加组别",
					width: "1030px",
					height: "643px",
					params: {
						matchId: this.matchId,
						currId: this.currId
					},
					callback: () => {
						this.rcurrentPage = 1;
						this.getRightPageLocal();
						this.getPageLocal()
					}
				})
			},
			async handleRowClick(row, column, event) {
				this.currId = row.id;
				this.rcurrentPage = 1;
				this.getRightPageLocal();
			},
			deleteItemType(row) {
				this.$confirm("确定删除该组别分类吗？", "提示").then(async (confirm) => {
					if (confirm === "confirm") {
						const res = await deleteGroupClassify({
							id: row.id
						});
						if (res && res.status == 200) {
							this.$message.success("删除成功");
							this.currentPage = 1;
							this.getPageLocal();
						} else {
							res && res.msg && this.$message.error(res.msg);
						}
					}
				})
			},
			getTypeStr(genderRequirements) {
				const types = new Map([
					["0", "双人组"],
					["1", "多人组"],
					["3", "单人组"]
				]);
				if (types.has(genderRequirements)) {
					return types.get(genderRequirements);
				} else {
					return "双人组";
				}
			},
			getMatchRulesStr(matchRules) {
				const types = new Map([
					["0", "等级赛"],
					["1", "名次赛"],
					["2", "奖金赛"],
					["3", "不限"],
					["4", "淘汰赛"],
					["5", "精英赛 "],
					["6", "竞技赛 "],
					["7", "进阶赛 "],
				]);
				if (types.has(matchRules)) {
					return types.get(matchRules);
				} else {
					return "--";
				}
			},
			getageStr(row){
				if((row.minAge && row.minAge != 0) && (!row.maxAge || row.maxAge == 0)){
					return `${row.minAge}岁及以上`;
				}
				if((!row.minAge || row.minAge == 0) && (row.maxAge && row.maxAge != 0)){
					return `${row.maxAge}岁及以下`;
				}
				if(row.minAge == row.maxAge && row.minAge>0){
					return `${row.maxAge}岁`;
				}
				if((row.minAge && row.minAge != 0) && (row.maxAge && row.maxAge != 0) && row.minAge != row.maxAge){
					return `${row.minAge}~${row.maxAge}岁`;
				}
				if((!row.minAge||row.minAge==0)||(!row.maxAge||row.maxAge==0)){
					return "不限";
				}
				return "--";
			},
			getgenderRequirementsStr(genderRequirements) {
				const types = new Map([
					["0", "不限"],
					["1", "男"],
					["2", "女"],
					["3", "男女"],
					["4", "女女"],
				]);
				if (types.has(genderRequirements)) {
					return types.get(genderRequirements);
				} else {
					return "不限";
				}
			},
			rsizeChange(val) {
				this.rpageSize = val;
				this.rcurrentPage = 1;
				this.getRightPageLocal();
			},
			rcurrentChange(val) {
				this.rcurrentPage = val;
				this.getRightPageLocal();
			},
			async getRightPageLocal() {
				const params = {
					currPage: this.rcurrentPage,
					pageSize: this.rpageSize,
					id: this.currId,
				}
				const res = await pageGroupDetailsByGroupClassifyId(params);
				if (res && res.status == 200) {
					this.rtotal = res.data.total;
					this.rightTableData = res.data.list;
				} else {
					res && res.msg && this.$message.error(res.msg);
				}
			},
			delGroupItem(row) {
				this.$confirm("确定删除该组别吗？", "提示").then(async (confirm) => {
					if (confirm === "confirm") {
						const res = await deleteGroupClassisfyGroupById({
							id: row.id
						});
						if (res && res.status == 200) {
							this.$message.success("删除成功");
							this.rcurrentPage = 1;
							this.getRightPageLocal();
							this.getPageLocal();
						} else {
							res && res.msg && this.$message.error(res.msg);
						}
					}
				})
			},
			async downloadGroup() {
				const res = await downloadGroupsOfGroupClass({
					id: this.currId
				});
				if (res) {
					var blob = new Blob([res], {type: "application/octet-stream"}); // application/vnd.ms-excel
					const item = this.leftTableData.find(item => item.id === this.currId);
					var aEl = document.createElement('a');
					var href = window.URL.createObjectURL(blob); //创建下载的链接
					aEl.href = href;
					aEl.download = `${item.classifyName}-组别设项.xls`; //下载后文件名
					aEl.click(); //点击下载
					window.URL.revokeObjectURL(href); //释放掉blob对象
				} else {
					res && res.msg && this.$message.error(res.msg);
				}
			},
			async deleteAllGroup(){
				this.$confirm("确定删除所有组别吗？", "温馨提示").then(async (confirm) => {
					if (confirm === "confirm") {
						const res = await deleteAllGroupClassifyGroups({
							id: this.currId
						});
						if (res && res.status == 200) {
							this.$message.success("删除成功");
							this.rcurrentPage = 1;
							this.getRightPageLocal();   					}
					}
				});
			}
		},
	};
</script>
<style lang="scss" scoped>
	.page-box {
		width: calc(100%);
		height: calc(100%);
		display: grid;
		grid-template-columns: 607px 60px 1fr;
		grid-template-rows: 1fr;

		.left {
			display: grid;
			grid-template-columns: 1fr;
			grid-template-rows: 60px 1fr 60px;

			.opt-btn {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				padding: 0 15px;
			}

			.table-box {
				background-color: #fff;
				height: calc(var(--height));
				overflow: hidden;

				::v-deep .el-table__body-wrapper {
					height: calc(100% - 37px);
					overflow-y: auto;

					.current-row {
						td {
							// background-color: #01A7F0;

							.arrow-icon {
								opacity: 1;
							}
						}
					}

					td {
						.arrow-icon {
							opacity: 0;
						}
					}
				}
			}

			.page {
				background-color: #fff;
				box-shadow: 0px -2px 8px #f2f2f2;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				padding-left: 15px;
			}
		}

		.right {
			display: grid;
			grid-template-columns: 1fr;
			grid-template-rows: 60px 1fr 60px;

			.opt-btn {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				padding: 0 15px;
			}

			.table-box {
				background-color: #fff;
				height: calc(var(--height));
				overflow: hidden;

				::v-deep .el-table__body-wrapper {
					height: calc(100% - 37px);
					overflow-y: auto;
				}
			}

			.page {
				background-color: #fff;
				box-shadow: 0px -2px 8px #f2f2f2;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				padding-left: 15px;

			}
		}

		::v-deep .el-button--danger {
			background-color: #F32C6C;
		}
	}
</style>